import React from "react";
import PropTypes from "prop-types";
import { RECIPES, RECIPE_SECTIONS } from "../recipes";

const RecipeGallery = ({ onSelect }) => (
  <div className="space-y-6">
    <p className="text-sm text-text-2">
      What spend do you want to track? Pick a starting point — you can adjust everything next.
    </p>
    {RECIPE_SECTIONS.map((section) => (
      <div key={section}>
        <p className="text-xs font-medium uppercase tracking-wide text-text-2 mb-2">{section}</p>
        <div
          className="grid gap-3"
          style={{ gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))" }}
        >
          {RECIPES.filter((r) => r.section === section).map((r) => (
            <button
              key={r.id}
              type="button"
              onClick={() => onSelect(r)}
              className="text-left bg-card border border-card-bd rounded-card p-3 hover:border-primary hover:bg-surface-2 transition-colors"
            >
              <span className="text-sm font-medium text-text">
                {r.icon} {r.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    ))}
  </div>
);

RecipeGallery.propTypes = { onSelect: PropTypes.func.isRequired };

export default RecipeGallery;
